import React, { useEffect } from "react";
import styles from "./NotFound.module.css";
import { ReactComponent as Illustration } from "./resources/undraw_not_found_60pq.svg";

export function NotFound404() {
	useEffect(() => {
		document.body.className = "whiteBackground";
		return () => {
			document.body.className = "";
		};
	});

	return (
		<div className={styles.notFound}>
			<h1>404 - Not found</h1>
			<Illustration />
		</div>
	);
}
